module.exports = __webpack_public_path__ + "static/media/panna-cotta.77e2b231.svg";